import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A gizmo that outlines a box: the 12 edges of an AABB in the colour a Godot gizmo plugin gives it.
 * The caller mounts it in a `PluginGizmo`.
 */
import { useMemo } from 'react';
import { aabbEdges } from '../../godot/math/aabb';
import { useGodotLinearColor } from '../godotColor';
import { GizmoLine } from './GizmoLine';
export function AabbGizmo({ aabb, color }) {
    const positions = useMemo(() => new Float32Array(aabbEdges(aabb)), [aabb]);
    return _jsx(GizmoLine, { positions: positions, color: useGodotLinearColor(color) });
}
//# sourceMappingURL=AabbGizmo.js.map